import React from 'react'
import fileDownload from 'js-file-download'
import * as request from 'superagent'
import { withRouter, Switch, Route, NavLink } from 'react-router-dom'

import {
  Button,
  Intent,
  ProgressBar
} from '@blueprintjs/core'

import { Toast } from '../Toaster'

import { auth } from '../firebase'
import getACL from './acl'

import { API_BASE_URL } from '../index'

import Approve from './Approve/Approve'
import Upload from './Upload/Upload'

import './Dash.css'

const redirector = (history, role) => {
  if (role.incl.includes('signingAuthority')) {
    history.push('/dash/approve')
  } else if (role.incl.includes('bookkeeper')) {
    history.push('/dash/upload')
  } else {
    history.push('/dash/noAuth')
  }
}

const logout = () => auth.signOut()

const Signout = ({ desktop }) => (
  <Button
    className='pt-minimal'
    iconName='log-out'
    onClick={logout}
    text={desktop && 'Log Out'}
  />
)

class Dash extends React.Component {
  constructor () {
    super()
    this.state = {
      acl: null,
      role: null
    }

    this.saveRoles = this.saveRoles.bind(this)
  }

  handleRoles () {
    if (this.props.user && !this.state.role) {
      const user = this.props.user
      const userRole = user.hasInfo
        ? user.info.role
        : ''
      getACL().then(acl => {
        const role = acl.hydrate(userRole).res
        this.saveRoles(acl, role)
      })
    }
  }

  saveRoles (acl, role) {
    this.setState({ acl, role })
  }

  download () {
    const key = Toast.show({
      message: <ProgressBar intent={Intent.PRIMARY} />,
      iconName: 'download',
      timeout: 0
    })

    request
      .post(API_BASE_URL + '/downloadCheques')
      .set('responseType', 'Blob')
      .send({ user: this.props.user })
      .then(json => {
        Toast.dismiss(key)
        if (json.ok) {
          fileDownload(new Uint8Array(json.body.data), 'signed_cheques.zip')
        } else {
          throw new Error('Network error')
        }
      })
      .catch(err => {
        Toast.dismiss(key)
        err = { ...err }
        Toast.show({
          message: err.response.text || err.message,
          iconName: 'warning-sign',
          intent: Intent.DANGER
        })
      })
  }

  render () {
    const props = this.props
    if (props.user && !this.state.role) {
      this.handleRoles()
    }
    const bodySize = document.body.offsetWidth
    const desktop = bodySize > 1024
    return (
      <div className='dash-body'>
        <nav className='pt-navbar'>
          <div className='pt-navbar-group pt-align-left'>
            <div className='pt-navbar-heading'>Seafarer</div>
          </div>
          <div className='pt-navbar-group pt-align-right'>
            {
              this.state.role && this.state.role.incl.includes('bookkeeper') &&
                <NavLink
                  strict
                  to='/dash/upload'
                  className='pt-button pt-minimal pt-icon-upload'
                  activeClassName='pt-intent-primary'
                >
                  { desktop && 'Upload Blank Cheques' }
                </NavLink>
            } {
              this.state.role && this.state.role.incl.includes('signingAuthority') &&
                <NavLink
                  strict
                  to='/dash/approve'
                  className='pt-button pt-minimal pt-icon-endorsed'
                  activeClassName='pt-intent-primary'
                  >
                    { desktop && 'Approve Cheques' }
                  </NavLink>
            } {
              this.state.role && this.state.role.incl.includes('bookkeeper') &&
                <Button className='pt-minimal'
                  iconName='download'
                  text={desktop && 'Download Signed Cheques'}
                  onClick={() => this.download()}
                />
            }
            <span className='pt-navbar-divider' />
            <Signout desktop={desktop} />
          </div>
        </nav>
        <div
          style={{
            padding: '20px'
          }}
        >
          <Switch>
            <Route exact path='/dash/' render={() => <Redirect {...props} role={this.state.role} />}
            />
            <Route exact path='/dash/upload' render={() => <Upload role={this.state.role} />} />
            <Route exact path='/dash/approve' render={() => <Approve role={this.state.role} user={this.props.user} />} />
          </Switch>
        </div>
      </div>
    )
  }
}

const Redirect = ({ history, role }) => (
  <div>
    { role && redirector(history, role) }
  </div>
)

export default withRouter(Dash)



// WEBPACK FOOTER //
// ./src/Private/Dash.js